export default __webpack_public_path__ + "static/media/SanathanTextile_Dec21'3502.08786216.jpg";